/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { CoreStrictHttpResponse } from '../../core-strict-http-response';
import { CoreRequestBuilder } from '../../core-request-builder';

import { CoreProjectUserBatchCreateDto } from '../../models/core-project-user-batch-create-dto';
import { CoreProjectUserResponseDto } from '../../models/core-project-user-response-dto';

export interface ProjectUsersControllerCreateBatch$Params {
  tenant: string;
      body: CoreProjectUserBatchCreateDto
}

export function projectUsersControllerCreateBatch(http: HttpClient, rootUrl: string, params: ProjectUsersControllerCreateBatch$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<Array<CoreProjectUserResponseDto>>> {
  const rb = new CoreRequestBuilder(rootUrl, projectUsersControllerCreateBatch.PATH, 'post');
  if (params) {
    rb.path('tenant', params.tenant, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as CoreStrictHttpResponse<Array<CoreProjectUserResponseDto>>;
    })
  );
}

projectUsersControllerCreateBatch.PATH = '/o2-core/project-users/{tenant}/batch';
